export const LINKING_LOAN_SUPPORT = {
  AU: {
    NUM: "1800734583",
    HOURS_WEEKDAY: "9am - 5pm (AEST)",
    HOURS_WEEKEND: "Closed",
  },
  NZ: {
    NUM: "0800321001",
    HOURS_WEEKDAY: "8am - 5:30pm (NZST)",
    HOURS_WEEKEND: "Closed",
  },
};

export const PAYMENT_LOAN_SUPPORT = {
  AU: {
    NUM: "1300369903",
    HOURS_WEEKDAY: "9am - 5pm (AEST)",
    HOURS_WEEKEND: "Closed",
  },
  NZ: {
    NUM: "0800321001",
    HOURS_WEEKDAY: "8am - 5:30pm (NZST)",
    HOURS_WEEKEND: "Closed",
  },
};

export const HARDSHIP_SUPPORT = {
  AU: {
    NUM: "1800 220 718",
    HOURS: "Mon–Fri between 8am and 5pm (AEST)",
  },
  NZ: {
    NUM: "0800 433 033 (or +64 9941 1736 from outside NZ)",
    HOURS: "Mon–Fri between 8am and 4.30pm (NZST)",
  },
};
export const STATIC_RESOURCES = {
  tncPdfAu: "/static/resources/au-latitude-service-centre.pdf",
  tncPdfNz:
    "https://assets.latitudefinancial.com/terms-and-conditions/latitude-service-centre-nz.pdf",
  debitCardServiceAgreementAu:
    "https://assets.latitudefinancial.com/legals/terms-conditions/debit-card-service-agreement-au.pdf",
  debitCardServiceAgreementNz:
    "https://assets.latitudefinancial.com/legals/terms-conditions/debit-card-service-agreement-nz.pdf",
  serviceAgreementUrl:
    "/static/resources/direct-debit-request-service-agreement.pdf",
};
